export default __webpack_public_path__ + "static/Detox_Bar-c32948509eff07b4378a5b4dafa3fcaa.jpg";